import SubmitMetaData from "./component/SubmitMetaData";
import SubmitQuestion from "./component/SubmitQuestion";
import {useEffect, useState} from "react";
import {Context} from "./component/Context";
import SearchResult from "./component/SearchResult";
import SearchExam from "component/const/SearchExam";
import StoreExam from "component/const/StoreExam";
import {Activate} from "component/const/ForCreate";
import {useLocation} from "react-router-dom";
import axios from "axios";
import {restUrl} from "../../../../../apiUrl";

export default function CreateShort() {
    const {state} = useLocation()
    const [metaData, setMetaData] = useState({
        testOverview:"",
        submitterMemo:"",
        pass:0,
        max:0,
        submitType: 0,
        totalDifficult: 0,
        totalMiddle: 0,
        totalEasy: 0,
    })
    const [value, setValue] = useState("객관식")
    const [problems, setProblems] = useState([])
    const [searching, setSearching] = useState("")
    const [result, setResult] = useState([])
    const [clicked, setClicked] = useState(0)

    useEffect(() => {
        StoreExam(metaData, problems)
    }, [clicked]);

    useEffect(() => {
        if (problems.length>0) {
            const max = problems.reduce((acc, problem) => {
                return acc + problem.score}, 0)
            const meta = {...metaData}
            meta.max = max
            setMetaData(meta)
        }
    }, [problems]);

    const search = () => {
        if (searching==="") alert("검색어를 입력해주세요.")
        else {
            Activate("searchResult")
            setResult(SearchExam(searching))
        }
    }

    useEffect(() => {
        init()
    }, []);

    const init = async () => {
        const tempts = localStorage.getItem(state.testId)
        let json
        try{
            json = JSON.parse(tempts)
        } catch (error) {
            console.log(error)
            json = null
        }
        if (json|| tempts) {
            setProblems(json)
        }
        else getProblems()
    }

    const getProblems = () => axios.get(`${restUrl}/activity_test_problem_view_short_create?test_id=eq.${state.testId}`)
        .then(res => res.data.map(item => {
            const problem = {}
            problem.id = item.id
            problem.test_id = item.test_id
            if (item.selections) {
                problem.selections = item.selections
                problem.answer = item.answer
            } else problem.answers = item.answers
            problem.title = item.problem
            problem.type = item.type
            problem.type = item.type
            problem.difficulty = item.difficulty
            problem.score = item.score
            return problem
        }))
        .then(data => setProblems(data))

    return (
        <>
            <Context.Provider value={{searching, setSearching, search, value, setValue,
                problems, setProblems, metaData, setMetaData, result, setResult, clicked, setClicked,}}>
            <SearchResult/>
            <SubmitMetaData testId={state.testId}/>
            <SubmitQuestion/>
            {/*<SubmitSave/>*/}
            </Context.Provider>
        </>
    )
}